/**
 * The signed-in person's feature votes: which items she wants, and her
 * "I want this" and take-back. Logic lives in `~/lib/server/feature-votes`.
 *
 * Aliases: feature votes api, vote for feature, i want this, take back vote
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { authMiddleware } from "~/lib/auth-middleware";
import { FEATURE_VOTE_KEYS } from "~/lib/shared/feature-votes/items";

export const featureVoteQueryKeys = {
  mine: ["feature-votes", "mine"] as const,
};

export const getMyFeatureVotesFn = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    const { listFeatureVoteKeys } = await import("~/lib/server/feature-votes");
    return listFeatureVoteKeys(context.user.id);
  });

export const myFeatureVotesQueryOptions = queryOptions({
  queryKey: featureVoteQueryKeys.mine,
  queryFn: () => getMyFeatureVotesFn(),
});

const SetFeatureVoteSchema = z.object({
  key: z.enum(FEATURE_VOTE_KEYS),
  wanted: z.boolean(),
});

export const setFeatureVoteFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(SetFeatureVoteSchema)
  .handler(async ({ data, context }) => {
    const { setFeatureVote } = await import("~/lib/server/feature-votes");
    return setFeatureVote(context.user.id, data.key, data.wanted);
  });
